import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import BannerBtnQuestionnaires from '@components/ui-components/banner-btn-questionnaires/component.js'
import builderConstructor from '@components/ui-components/builder/constructor/component.js'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'banner-btn-questionnaires-cmp': BannerBtnQuestionnaires,
    'builder-constructor': builderConstructor,
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/questionnaires/view/index.js